/* apex-form.js — the contact and request forms.

   The floating label is CSS: the control sits before its label, so :focus and
   :not(:placeholder-shown) lift it without help. This file only does the parts
   CSS cannot.

   1. A field that arrives with a value — a browser restoring a submission, an
      autofill — needs its label already lifted. :not(:placeholder-shown) covers
      typing but not a value set before first paint.
   2. On a failed submit, move focus to the first field the browser rejected and
      say what is wrong in one place, rather than leaving the reader to hunt.
   3. On a successful post, bring the confirmation into view. Shopify reloads
      the page at the top; the banner sits inside the form, further down. */
(function () {
  var forms = [].slice.call(document.querySelectorAll('[data-agsfrm]'));
  if (!forms.length) return;

  forms.forEach(function (form) {

    /* ── labels that must start lifted ─────────────────────────────────── */
    function sync(el) {
      var f = el.closest('.frm__f');
      if (!f) return;
      /* a select or a date is always showing something; the stylesheet marks
         those up front and they must stay marked */
      if (el.tagName === 'SELECT' || el.type === 'date') return;
      f.classList.toggle('frm__f--up', !!el.value);
    }
    var fields = [].slice.call(form.querySelectorAll('.frm__f input, .frm__f select, .frm__f textarea'));
    fields.forEach(function (el) {
      sync(el);
      el.addEventListener('change', function () { sync(el); });
    });
    /* autofill can land after first paint without firing input */
    window.addEventListener('pageshow', function () { fields.forEach(sync); });

    /* ── the message a successful post leaves behind ───────────────────── */
    var ok = form.querySelector('[data-agsfrm-ok]');
    if (ok) {
      /* Shopify sends the reader back to the top of the page after a contact
         post, and on the two-column layout the form starts well below the fold.
         Without this the confirmation is rendered and never seen. Focus first
         with the scroll suppressed, then centre it, so the focus ring does not
         land the banner under the sticky header. */
      /* on a phone the form is the second column, so the banner rendered
         roughly 730px down behind the whole supporting list. Marking the
         layout lets the stylesheet lift the form above that column at phone
         widths; on desktop, where both are visible at once, nothing moves. */
      var lay = form.closest('.clayout2');
      if (lay) lay.classList.add('is-sent');
      try { ok.focus({ preventScroll: true }); } catch (e) { ok.focus(); }
      ok.scrollIntoView({ block: 'center' });
    }

    /* ── the error summary ─────────────────────────────────────────────── */
    var summary = form.querySelector('[data-agsfrm-err]');

    form.addEventListener('submit', function (e) {
      if (form.checkValidity()) {
        if (summary) summary.hidden = true;
        return;
      }
      e.preventDefault();

      var bad = [].slice.call(form.querySelectorAll(':invalid')).filter(function (el) {
        return el.closest('.frm__f');
      });
      if (!bad.length) return;

      if (summary) {
        var list = summary.querySelector('ul');
        list.innerHTML = '';
        bad.forEach(function (el) {
          var lab = el.closest('.frm__f').querySelector('label');
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '#' + el.id;
          /* the label carries an "optional" span; a required field has none,
             but strip it defensively so the message is only the field name */
          a.textContent = (lab ? lab.textContent : el.name).replace(/\s*optional\s*$/, '').trim();
          a.addEventListener('click', function (ev) {
            ev.preventDefault();
            el.focus();
          });
          li.appendChild(a);
          list.appendChild(li);
        });
        summary.hidden = false;
        summary.setAttribute('tabindex', '-1');
        summary.focus();
      }

      bad[0].focus();
    });
  });
})();
